import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLTextAreaElement> {
  connect(): void {
    this.resize()
    this.element.addEventListener("input", () => this.resize())
  }

  private resize(): void {
    this.element.style.height = "auto"
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
